const Validator = {
  email: {
    rules: [
      {
        test: /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i,
        message: 'Please Enter Valid Email',
      },
    ]
  },
  phoneNumber: {
    rules: [
      {
        test: /^[0-9.\- ]+$/,
        message: 'Please Enter Valid Phone number',
      },
    ]
  },
  oldPassword: {
    rules: [
      {
        test: (value) => {
          return value.length >= 8;
        },
        message: 'Password can not be < 8 characters',
      },
      {
        test: /^[a-z0-9A-Z_?!@#$&().,;:+*|£%\-\\ˆàéèìòù€\[\]]+$/,
        //test: /^[a-z0-9A-Z_?!@#$&().,;:+*|£%\-\\ˆàéèìòù€]+$/,
        // test: /^[a-z0-9A-Z_]+$/,
        message: 'Enter Valid Password',
      },
    ]
  },
  newPassword: {
    rules: [
      {
        test: (value) => {
          return value.length >= 8;
        },
        message: 'Password can not be < 8 characters',
      },
      {
        test: /^[a-z0-9A-Z_?!@#$&().,;:+*|£%\-\\ˆàéèìòù€\[\]]+$/,
        message: 'Enter Valid Password',
      },
    ]
  },
  confirmPassword: {
    rules: [
      {
        test: (value) => {
          return value.length >= 8;
        },
        message: 'Password can not be < 8 characters',
      },
      {
        test: /^[a-z0-9A-Z_?!@#$&().,;:+*|£%\-\\ˆàéèìòù€\[\]]+$/,
        message: 'Enter Valid Password',
      },
    ]
  },
  
};

export default Validator;